<template>
  <a-breadcrumb class="breadcrumb-box">
    <a-breadcrumb-item
      v-for="(item, index) in routes"
      :key="index"
    >
      <span v-if="index === 0 || index === routes.length - 1">{{ item.breadcrumbName }}</span>
      <a
        v-else
        :href="item.path"
      >{{ item.breadcrumbName }}</a>
    </a-breadcrumb-item>
  </a-breadcrumb>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    routes: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {}
  }
}
</script>

<style lang="less">
.breadcrumb-box {
  padding-top: 16px;
  padding-left: 16px;
  padding-right: 16px;
}
</style>
